module.exports = __webpack_public_path__ + "static/BDST-Regular-c185ca420ce0e1e58cc1d303907ac749.otf";